import { z } from 'zod';
import { supabase } from '@/shared/supabase/client';
import type { DepotReleves, ReleveEnregistre } from '../types';
import { messageRefus } from './lignes-chantiers';

/**
 * Le relevé de la visite technique (db/019-visite-technique.sql). Le partenaire
 * de l'étape l'écrit tant qu'elle n'est ni envoyée ni validée ; le bureau, toujours.
 */
const ligneReleve = z.object({
  donnees: z.unknown(),
  complet: z.boolean(),
  version: z.number(),
  maj_le: z.string(),
});

function versReleve(l: z.infer<typeof ligneReleve>): ReleveEnregistre {
  return { donnees: l.donnees, complet: l.complet, version: l.version, majLe: l.maj_le };
}

export const relevesSupabase: DepotReleves = {
  async lire(etapeId) {
    const { data, error } = await supabase()
      .from('releves')
      .select('donnees, complet, version, maj_le')
      .eq('etape_id', etapeId)
      .maybeSingle();
    if (error) throw new Error(messageRefus(error, 'Le relevé n’a pas pu être lu.'));
    return data === null ? null : versReleve(ligneReleve.parse(data));
  },

  async enregistrer(etapeId, donnees, complet) {
    const { data, error } = await supabase()
      .from('releves')
      .upsert({ etape_id: etapeId, donnees, complet }, { onConflict: 'etape_id' })
      .select('donnees, complet, version, maj_le')
      .single();
    if (error) {
      throw new Error(
        messageRefus(
          error,
          'Le relevé n’a pas pu être enregistré. Une étape envoyée au bureau ou validée ne se modifie plus.'
        )
      );
    }
    return versReleve(ligneReleve.parse(data));
  },
};
